import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { CartProvider } from './store/cart';
import { Home } from './pages/Home';
import { Catalog } from './pages/Catalog';
import { Product } from './pages/Product';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { Payment } from './pages/Payment';
import { Confirmation } from './pages/Confirmation';
import { Account } from './pages/Account';
import { Contact } from './pages/Contact';

export function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <Routes>
          {/* Strona operatora płatności — poza layoutem sklepu. */}
          <Route path="/platnosc" element={<Payment />} />

          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="katalog" element={<Catalog />} />
            <Route path="produkt/:slug" element={<Product />} />
            <Route path="koszyk" element={<Cart />} />
            <Route path="zamowienie" element={<Checkout />} />
            <Route path="potwierdzenie/:orderId" element={<Confirmation />} />
            <Route path="konto" element={<Account />} />
            <Route path="kontakt" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </CartProvider>
    </BrowserRouter>
  );
}
